import { createExternalRouteRef } from '@backstage/frontend-plugin-api';

// Where tool results link to. Bound by default, so installing catalog and
// scaffolder is enough; an unbound ref renders the result without a link.
export const catalogEntityRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
  defaultTarget: 'catalog.catalogEntity',
});

export const scaffolderTemplateRouteRef = createExternalRouteRef({
  params: ['namespace', 'templateName'],
  defaultTarget: 'scaffolder.selectedTemplate',
});

export const scaffolderTaskRouteRef = createExternalRouteRef({
  params: ['taskId'],
  defaultTarget: 'scaffolder.ongoingTask',
});
